import { ColumnDef } from '@tanstack/react-table'
import dayjs from 'dayjs'
import { toast } from 'sonner'
import * as XLSX from 'xlsx'

export const exportExcel = (
  rows: { [key: string]: string }[],
  columns: { id: string; header: string }[],
  name: string,
) => {
  const workbook = XLSX.utils.book_new()
  const worksheet = XLSX.utils.aoa_to_sheet([])

  XLSX.utils.sheet_add_aoa(
    worksheet,
    [
      columns
        .filter((column) => column.id !== 'checkbox')
        .map((column) => column.header),
    ],
    { origin: 'A1' },
  )
  XLSX.utils.sheet_add_aoa(
    worksheet,
    rows.map((row) => {
      const dataRow = columns
        .filter((column) => column.id !== 'checkbox')
        .map((column) => row[column.id as string])
      return dataRow as string[]
    }),
    {
      origin: 'A2',
    },
  )

  XLSX.utils.book_append_sheet(workbook, worksheet, 'data')

  XLSX.writeFile(workbook, `${dayjs().format('YYYYMMDD_HH:mm')}_${name}.xlsx`, {
    compression: true,
  })
}

export const exportTableToExcel = (table: HTMLElement | null, name: string) => {
  if (!table) {
    toast.error('[개발 오류] 테이블 없음. (no ref?)')
    return
  }

  const elementCopy = table.cloneNode(true) as HTMLTableElement

  const rows = elementCopy.querySelectorAll('tbody > tr')

  rows.forEach((row) => {
    const isUnchecked = row.querySelector(
      '[data-checkbox-column][data-state="unchecked"]',
    )
    if (isUnchecked) {
      row.remove()
    }
  })

  const workbook = XLSX.utils.book_new()

  const worksheet = XLSX.utils.table_to_sheet(elementCopy, { raw: false })

  // delete_row(worksheet, )

  XLSX.utils.book_append_sheet(workbook, worksheet, 'data')

  /**
   *  체크박스 컬럼 확인해서 안보이게 처리
   */
  if (worksheet['!cols'] && !worksheet.A1?.v) {
    worksheet['!cols'][0] = { hidden: true }
  }

  XLSX.writeFile(workbook, `${dayjs().format('YYYYMMDD_HH:mm')}_${name}.xlsx`, {
    compression: true,
  })
}

function ec(r: number, c: number) {
  return XLSX.utils.encode_cell({ r: r, c: c })
}

function delete_row(ws: XLSX.WorkSheet, row_index: number) {
  const variable = XLSX.utils.decode_range(ws['!ref'] || '')
  for (let R = row_index; R < variable.e.r; ++R) {
    for (let C = variable.s.c; C <= variable.e.c; ++C) {
      ws[ec(R, C)] = ws[ec(R + 1, C)]
    }
  }
  variable.e.r--
  ws['!ref'] = XLSX.utils.encode_range(variable.s, variable.e)
}
